import { phoneAllowedCharacters, phoneValidation } from '../../constants/validityPatterns';
import transformPhone from '../transformPhoneNumber';

/**
 * Validates the string that will actually be SUBMITTED, not the one on screen.
 *
 * That is the whole point of running transformPhone first. The field may legitimately hold spaces -
 * pasted, or left over from the old mask - and those never reach the API, so validating the raw
 * value would reject input that would have saved perfectly well.
 *
 * It used to count digits and require exactly 11. That did not merely fail to allow international
 * numbers, it got them WRONG: `+33612345678` strips to eleven digits and passed, then went to the
 * API with its + removed. A shared pattern replaces the count.
 *
 * @param {string} value
 * @returns {boolean}
 */
export default function validatePhone(value) {
    const raw = value ? String(value).trim() : '';

    // Refuse before transforming. transformPhone discards separators, so a character it does not
    // understand - the `x` of an extension, a letter, a stray symbol - disappears and its DIGITS
    // stay, joining the number. Checking the shape first means such input fails visibly instead of
    // being saved as a different, dialable-looking, wrong number.
    if (!phoneAllowedCharacters.test(raw)) {
        return false;
    }

    return phoneValidation.test(transformPhone(raw) || '');
}
